export default ({ breakpoints, spacing }) => ({
  addButton: {
    bottom: spacing.unit * 5,
    position: 'fixed',
    right: spacing.unit * 5
  },
  searchInput: {
    marginBottom: spacing.unit * 2,
    marginTop: spacing.unit * 2,
    [breakpoints.down('md')]: {
      marginLeft: spacing.unit * 2,
      marginRight: spacing.unit * 2
    }
  }
})



// WEBPACK FOOTER //
// ./src/views/ProviderList/Main/styles.js